export const POSTER_DEMO_DATA = {
  passFront: {
    matchDetailsTitle: 'Additional Ticket Info',
    matchDetailsSubtitle: 'Gate, Match and More',
    viewInMapsCard: { title: 'River Park Stadium', action: 'Open in Maps' },
    eventGuideCard: {
      title: 'Bath Rugby vs Leicester Tigers',
      action: 'Event Guide',
    },
    poster: {
      event: 'Bath Rugby vs\nLeicester Tigers',
      date: '06 JUNE',
      time: '15:15',
      info: 'South Stand',
      section: 'SSB',
      row: 'C',
      seat: '18',
      venue: 'River Park Stadium',
    },
  },
  event: {
    game: 'Bath Rugby vs Leicester Tigers',
    eventLabel: 'Gallagher PREM · Round 17',
    date: 'Saturday 6 June 2026',
    kickOff: '15:15',
    kickOffDisplay: '3.15pm',
    gatesOpen: '13:15',
    venueCurfew: '19:30',
  },
  venue: {
    name: 'River Park Stadium',
    shortName: 'The Rec, Bath',
    weatherCity: 'Bath',
    lat: 51.380556,
    lng: -2.355833,
    phone: '01225 325200',
    email: 'info@bathrugby.com',
  },
  ticket: {
    gate: 'South Gate',
    seat: 'South Stand · SSB · Row C · Seat 18',
    ticketHolder: 'John Smith',
    ticketType: 'General Admission',
  },
  weather: {
    tempHigh: '19°',
    tempLow: '7°',
    condition: 'Clear',
  },
  matchInfoHeader: 'Additional Ticket Info',
  urls: {
    policy: 'https://www.bathrugby.com/club/ground-regulations',
    food: 'https://www.bathrugby.com/club/food-and-drink',
    transit: 'https://www.bathrugby.com/getting-to-the-rec-public-transport',
    parking: 'https://www.bathrugby.com/getting-to-the-rec-by-car',
    visit: 'https://www.bathrugby.com/getting-to-the-rec',
    merch: 'https://bathrugbyshop.com/',
    access: 'https://www.bathrugby.com/accessibility-at-the-rec',
    addOn:
      'https://www.bathrugby.com/content/upgrade-your-matchday-explore-hospitality-at-the-rec',
    website: 'https://www.bathrugby.com/',
  },
} as const;
